"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManualTriggerParamDataType = exports.Views = exports.StringOperator = exports.NumericOperator = exports.TriggerParamsValueType = exports.TimeTriggerUnitOfTime = exports.AlertSeverity = void 0;
var AlertSeverity;
(function (AlertSeverity) {
    AlertSeverity[AlertSeverity["Low"] = 1] = "Low";
    AlertSeverity[AlertSeverity["Medium"] = 2] = "Medium";
    AlertSeverity[AlertSeverity["High"] = 3] = "High";
})(AlertSeverity || (exports.AlertSeverity = AlertSeverity = {}));
var TimeTriggerUnitOfTime;
(function (TimeTriggerUnitOfTime) {
    TimeTriggerUnitOfTime["MINUTES"] = "minutes";
    TimeTriggerUnitOfTime["HOURS"] = "hours";
    TimeTriggerUnitOfTime["DAYS"] = "days";
})(TimeTriggerUnitOfTime || (exports.TimeTriggerUnitOfTime = TimeTriggerUnitOfTime = {}));
var TriggerParamsValueType;
(function (TriggerParamsValueType) {
    TriggerParamsValueType["ChangedTo"] = "ChangedTo";
    TriggerParamsValueType["ChangedBy"] = "ChangedBy";
    TriggerParamsValueType["Changed"] = "Changed";
    TriggerParamsValueType["Added"] = "Added";
    TriggerParamsValueType["Removed"] = "Removed";
})(TriggerParamsValueType || (exports.TriggerParamsValueType = TriggerParamsValueType = {}));
var NumericOperator;
(function (NumericOperator) {
    NumericOperator["LESS_THAN"] = "LESS_THAN";
    NumericOperator["LESS_THAN_OR_EQUALS"] = "LESS_THAN_OR_EQUALS";
    NumericOperator["GREATER_THAN"] = "GREATER_THAN";
    NumericOperator["GREATER_THAN_OR_EQUALS"] = "GREATER_THAN_OR_EQUALS";
    NumericOperator["EQUALS"] = "EQUALS";
    NumericOperator["NOT_EQUALS"] = "NOT_EQUALS";
})(NumericOperator || (exports.NumericOperator = NumericOperator = {}));
var StringOperator;
(function (StringOperator) {
    StringOperator["EQUALS"] = "EQUALS";
    StringOperator["NOT_EQUALS"] = "NOT_EQUALS";
    StringOperator["INCLUDE"] = "INCLUDE";
    StringOperator["EXCLUDE"] = "EXCLUDE";
})(StringOperator || (exports.StringOperator = StringOperator = {}));
var Views;
(function (Views) {
    Views["Fleet"] = "FLEET";
})(Views || (exports.Views = Views = {}));
var ManualTriggerParamDataType;
(function (ManualTriggerParamDataType) {
    ManualTriggerParamDataType["BOOLEAN"] = "boolean";
    ManualTriggerParamDataType["STRING"] = "string";
    ManualTriggerParamDataType["NUMBER"] = "number";
    ManualTriggerParamDataType["DATE"] = "date";
    ManualTriggerParamDataType["TIME"] = "time";
})(ManualTriggerParamDataType || (exports.ManualTriggerParamDataType = ManualTriggerParamDataType = {}));
//# sourceMappingURL=alerts_configuration.js.map